import './assets/main.css'
import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router';
import FlagIcon from 'vue-flag-icon';
import axios from 'axios';
import store from "./store";
import i18n, { i18nPlugin } from './plugins/i18n';
import dateUtils from '@/plugins/date-utils';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import APICall from '@/api/call';
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import {version} from "./../package.json";
import { Icon } from '@iconify/vue';
import $ from 'jquery';

const app = createApp(App);

// สำคัญ: ต้องใช้งาน Vuetify ก่อน plugins อื่นๆ
app.use(vuetify)
// จากนั้นค่อยใช้ plugins อื่นๆ
app.component('Icon', Icon);
app.use(FlagIcon);
app.use(VueSweetalert2);
app.use(APICall);
app.use(i18nPlugin);
app.use(i18n);
app.use(store);
app.use(router);

// ตั้งค่า global properties
app.config.globalProperties.$http = axios;
app.config.globalProperties.$http.defaults.withCredentials = true;
app.config.globalProperties.$http.defaults.timeout = 500000;
window.$ = window.jQuery = $;
app.config.productionTip = false;

// กำหนดค่าโกลบอล
app.config.globalProperties.$dateUtils = dateUtils;
app.config.globalProperties.$version = version;

// import static files
import('@/assets/styles/table.css');
import('@/assets/styles/popup.css');
import('@/assets/styles/globals.css');
import('@/assets/styles/swal-delete.css');
import('@/assets/styles/swal-warning.css');

// กำหนดข้อมูลโกลบอล
app.provide('SetPopup', false);
app.provide('IsAllowImage', false);
app.provide('overlay', false);

// Mount app
app.mount('#app');

